import { Grid } from "@mui/material";
import { OLButton } from "OLButton";
import { FormSection } from "components/FormControls/FormSection";
import { FieldArray } from "formik";
import { useMessage } from "hooks/intl";
import { memo, useMemo } from "react";
import { TransactionItem } from "types/transactions";
import { Product } from "./Product";

export const TransactionProducts = memo(
  ({
    isFormDataReady,
    items,
  }: {
    isFormDataReady: boolean;
    items: TransactionItem[];
  }) => {
    const { message } = useMessage();
    const memoizedItems = useMemo(() => items, [items]);

    return (
      <>
        <FormSection
          isLoading={!isFormDataReady}
          title={message({ id: "productsInTheTransaction" })}
        >
          <FieldArray
            name="items"
            render={(arrayHelpers) => (
              <>
                {memoizedItems?.map((_, index) => (
                  <Product
                    key={index}
                    index={index}
                    remove={arrayHelpers.remove}
                  />
                ))}
                <Grid container spacing={10}>
                  <Grid xs={12} md={4} lg={3} item mt="1rem">
                    <OLButton
                      variant="outlined"
                      onClick={() =>
                        arrayHelpers.push({
                          category: "",
                          grossValue: "",
                          maker: "",
                          name: "",
                          highPrecisionQuantity: undefined,
                          sku: "",
                          labels: [],
                        })
                      }
                      data-test-id="add-product-button"
                    >
                      {message({ id: "addProduct" })}
                    </OLButton>
                  </Grid>
                </Grid>
              </>
            )}
          />
        </FormSection>
      </>
    );
  },
);
